import { ClienteXCiudad, ClienteLogin } from "../../login/cliente_login";
import { CampoValor } from "./datos_generales_entity";


export class DeclaracionesEntity {
    constructor(
        public CodigoPoliza?: number,
        public NumeroPoliza?: string,
        public CodigoCiudad?: number,
        public CodigoUnidad?: number,
        public CodigoAseguradora?: number,
        public CodigoRamo?: string,
        public CodigoEmpleado?: number,
        public CodigoCliente?: number,
        public FechaInicioVigencia?: string,
        public FechaFinVigencia?: string,
        public Periodicidad?: CampoValor,        
        public NombreAseguradora?: string,
        public NombreRamo?: string,
        public NombreEmpleado?: string,
        public CodigoDeclaracion?: number,
        public DireccionesMercaderias?: DireccionMercaderia[],
        public Valuacion?: CampoValor,
        public PrimaEnDeposito?: boolean,
        public Modalidad?: number
    ) { }
}

export class DireccionMercaderia {
    constructor(
        public CodigoItem?: number,
        public DetalleItem?: string,
        public ValorDeclarado?: string,
        public Modalidad?: string,
        public Tasa?: number,
        public ValorEstimado?: number,
        public ValorLimite?: number,
        public Declaraciones?: Declaracion[],
    ) { }
}

/* export class Declaracion {
    constructor(
        public CodigoDeclaracion?: number,
        public Mes?: string,
        public Anio?: string,
        public ValorDeclarado?: number,
        public ValorReal?: number,
        public Prima?: number,
        public Estado?: number,
        public FechaIngreso?: string,
        public Tasa?: number,
        public CodigoCiudad?: number,
        public CodigoDecDeclaracion?: number,
        public Ramo?: string
    ) { }
} */

export class DeclaracionUsuario {
    constructor(
        public Declaraciones?: Declaracion,
        public Cliente?: ClienteLogin,
        public ClienteSelect?: ClienteXCiudad,
        public DireccionMercaderia?: string,
        public Poliza?: DeclaracionesEntity,
        public Observaciones?: string
    ) { }
}

export class DireccionRubroIncendio {

    constructor(
        public CodigoBien?: number,
        public CodigoDireccion?: number,
        public Tasa?: number,
        public LimiteAsegurado?: number,
        public Direccion?: string,
        public Rubro?: string,
        public Periodicidad?: CampoValor,
        public Valuacion?: CampoValor,
        public CodigoTasa?: number,
        public NumeroItem?: number
    ) {
    }
};

export class DetalleDeclaracion {

    constructor(
        public CodigoDetDeclaracion?: number,
        public Mes?: string,
        public Anio?: string,
        public FechaMesAnio?: Date,
        public Periodo?: number,
        public ValorDeclarado?: number,
        public ValorAjuste?: number,
        public Seleccionado?: boolean,
        public Habilitado?: boolean,
        public PrimaNeta?: number,
        public NumeroPersonas?: number
    ) {
    }
};

export class Declaracion {

    constructor(
        public CodigoBien?: number,
        public CodigoMercaderia?: number,
        public CodigoGrupo?: number,
        public CodigoCabDeclaracion?: number,
        public CodigoPoliza?: number,
        public DetalleDeclaraciones?: DetalleDeclaracion[]
    ) {
    }
};

export class Mercaderia {

    constructor(
        public CodigoPoliza?: number,
        public CodigoMercaderia?: number,
        public DescripcionMercaderia?: string,
        public ValorAsegurado?: number,
        //public CodigoValuacion?: number,
        public EstimadoMovilizacion?: number,
        public Tasa?: number,
        public Valuacion?: CampoValor,
        public CodigoTasa?: number,
        public Periodicidad?: CampoValor,
        public AccionCrud?: string,
        public DatosPoliza?: DeclaracionesEntity
    ) {
    }
};


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/declaracion_entity.ts